<template>
  <section class="box" style="margin-top: 1.5rem">
    <h2 class="title is-6">{{ lang('Upload limit') }}</h2>

    <div class="field is-grouped">
      <div class="control">
        <input
          class="input"
          type="number"
          min="1"
          step="1"
          style="width: 10rem"
          v-model.number="sizeMb"
          :disabled="loading"
        >
      </div>
      <div class="control">
        <span class="button is-static">MB</span>
      </div>
      <div class="control">
        <button
          class="button is-primary"
          :class="{ 'is-loading': saving }"
          :disabled="loading"
          @click="save"
        >{{ lang('Save') }}</button>
      </div>
    </div>

    <p class="help">{{ lang('Upload limit help') }}</p>
    <p class="help" v-if="phpLimit">{{ lang('Current PHP limit', phpLimit) }}</p>
  </section>
</template>

<script>
import api from '../../api/api'

export default {
  name: 'SettingsUpload',
  data() {
    return {
      sizeMb: 0,
      phpLimit: '',
      loading: true,
      saving: false,
    }
  },
  mounted() {
    api.getSettings()
      .then(ret => {
        this.sizeMb = Math.round(ret.upload_max_size / 1048576)
        this.phpLimit = ret.php_upload_limit
        this.loading = false
      })
      .catch(error => {
        this.loading = false
        this.handleError(error)
      })
  },
  methods: {
    save() {
      if (!this.sizeMb || this.sizeMb < 1) {
        this.$toast.open({
          message: this.lang('Value must be at least 1 MB'),
          type: 'is-danger',
        })
        return
      }
      this.saving = true
      api.saveSettings({ upload_max_size: this.sizeMb * 1048576 })
        .then(ret => {
          this.saving = false
          // Cập nhật luôn cấu hình đang nạp trong trình duyệt, nếu không thì
          // phải tải lại trang mới thấy giới hạn mới có hiệu lực.
          this.$store.state.config.upload_max_size = ret.upload_max_size
          this.$toast.open({
            message: this.lang('Updated'),
            type: 'is-success',
          })
        })
        .catch(error => {
          this.saving = false
          this.handleError(error)
        })
    },
  },
}
</script>
